import React from 'react';
import {Row, Col, Card, Form, Button, InputGroup, FormControl, DropdownButton, Dropdown} from 'react-bootstrap';
import Select from 'react-select';
import {Link, useParams} from 'react-router-dom';
import icon from "../../assets/images/fi_upload.svg";
import axios from 'axios'
import API_URL from '../../constants'
import Aux from "../../hoc/_Aux";

class EditBerita extends React.Component {
    constructor(){
        super();
        
        this.state = {

            title: '',
            content: '',
            image: null,
            author: '',
            getImage : null
        };
      }
    
    
    componentDidMount(){
        this.getBeritaById()
    }
    handleChange = event =>{
        this.setState({ [event.target.name]:event.target.value })
    }

    onImageChange = event => {
        this.setState({ 
            image: event.target.files[0],
            getImage : URL.createObjectURL(event.target.files[0])
        });
    }

    handleChangeSelect (e) {
        this.setState({category: e });
    }
    
    getBeritaById = async() => {
        await axios.get(`${API_URL}` + `news/` + this.props.match.params.id )
        .then(res => {
            let detail = res.data
            this.setState({
                title: detail.title,
                content :detail.content,
                category : detail.category,
                image : detail.image,
                author : detail.author,
                created_at : detail.created_at,
            })
        })
    }

    handleSubmit =  () => {
        if (this.state.image !== null) {
            let data = new FormData();
            data.set("title", this.state.title);
            data.set("content", this.state.content);
            data.append("image", this.state.image);
            data.set("author", this.state.author);
            
      
            axios
              .put(`${API_URL}` + "news/" + this.props.match.params.id, data)
              .then(response => {
                if(response.status === 200){
                  console.log(response)
                  alert("Berita Berhasil Diubah!")
                  this.props.history.push('/berita')
                  window.location.reload()
                  console.log(response)
                }
            })
              .catch(error => console.log(error));
          }
    }


    render() {
      
        return (
            <Aux>
                <Row>
                    <Col>
                        <Card style={{borderRadius:12}}>
                            <Card.Header style={{border:0,paddingBottom: 0}}>
                                <div className="d-inline">
                                    <Link to={'/berita'} style={{color:'#000000'}}><i className=" text-lg fa fa-arrow-left" style={{fontSize:18,fontStyle:'#000000'}}></i></Link>
                                    <span style={{fontSize:24,fontWeight:'bold',marginLeft:20}}>Edit Berita</span>
                                </div>
                            </Card.Header>
                            <Card.Body style={{paddingTop: 0}} >
                                
                                    <Row style={{marginBottom: 80}}> 
                                        <Col xs={12} sm={6}>
                                                <label style={{fontSize:14,marginTop:16,marginBottom:8,fontWeight:'bold' }}>Judul Berita</label>
                                                <div className="input-group">
                                                    <input style={{width:'70%',border:0,borderRadius: 12,backgroundColor:'#EFEFEF'}} type="text" className="form-control text-left"  placeholder="Masukkan Judul Berita"  onChange={e => this.setState({title : e.target.value})} value={this.state.title} />
                                                </div>
                                                <label style={{fontSize:14,marginTop:16,marginBottom:8,fontWeight:'bold' }}>Isi Berita</label>
                                                <div className="input-group">
                                                    <textarea style={{width:'70%',border:0,borderRadius: 12,backgroundColor:'#EFEFEF'}} rows="8" className="form-control text-left"  placeholder="Masukkan Isi Berita" name="content"  onChange={e => this.setState({content : e.target.value})} value={this.state.content} />
                                                </div>
                                        </Col>

                                        <Col xs={12} sm={6}>
                                            <label style={{fontSize:14,marginTop:16,marginBottom:8,fontWeight:'bold' }}>Pembuat Berita</label>
                                            <div className="input-group">
                                                <input style={{width:'70%',border:0,borderRadius: 12,backgroundColor:'#EFEFEF'}} type="text" className="form-control text-left"   placeholder='Masukkan Pembuat Berita' name="author"  onChange={e => this.setState({author : e.target.value})} value={this.state.author} />
                                            </div>

                                            <label style={{fontSize:14,marginTop:16,marginBottom:8,fontWeight:'bold' }}>Gambar</label>
                                            <Row>
                                                <Col xs='12'>
                                                    <input style={{width:'100%',border:0,borderRadius: 12,backgroundColor:'#EFEFEF'}} type="file" className="form-control text-left"   placeholder='Masukkan gambar' name="image"  onChange={this.onImageChange}  />
                                                </Col>
                                            </Row>

                                            <label style={{fontSize:14,marginTop:16,marginBottom:8,fontWeight:'bold' }}>Preview Gambar</label>

                                            <div style={{width:'100%',border:0,borderRadius: 12,backgroundColor:'#EFEFEF'}}>
                                                <img src={this.state.getImage === null ? this.state.image : this.state.getImage} style={{width:'100%',heigt:'100%'}}></img>
                                            </div>

                                            
                                        </Col>         
                                    </Row>

                                    <Row>
                                        <Col xs={9}>
                                        </Col>
                                        <Col xs={3}>
                                            <div className="text-right">
                                                <Link to={'/berita'}><Button variant="light" className="text-danger font-weight-bold" >Batalkan</Button></Link>
                                                <Button variant="danger" type="submit" onClick={this.handleSubmit}  className="text-white font-weight-bold" style={{borderRadius: 8,width:121,height:37,padding:'8px 33px' }} >Submit</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Aux>
        );
    }
}

export default EditBerita;
